import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";

import { auth, firestore } from "../../../firebase";
import * as actions from "../../../store/actions";

import Input from "../../UI/Input/Input";
import Spinner from "../../UI/Spinner/Spinner";
import classes from "./AccountSettings.module.css";

const AccountSettings = (props) => {
  const [sameAsOldError, setSameAsOldError] = useState(false);
  const [passwordResetSuccess, setPasswordResetSuccess] = useState(false);
  const [loginError, setLoginError] = useState(null);
  const [hasPassword, setHasPassword] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  // Check if user is logged in with email and password
  useEffect(() => {
    for (let provider of auth.currentUser.providerData) {
      if (provider.providerId === "password") {
        setHasPassword(true);
        break;
      }
    }
  }, []);

  const deleteAccount = () => {
    if (window.confirm("Are you sure you want to deactivate your account?")) {
      firestore
        .collection("users")
        .doc(props.userId)
        .delete()
        .then(() => {
          auth.signOut();
        });
      props.onUpdatePurchased([]);
    }
  };

  const onSubmit = (data) => {
    setPasswordResetSuccess("loading");
    auth
      .signInWithEmailAndPassword(props.email, data.oldPassword)
      .then(() => {
        setLoginError(null);
        if (data.newPassword === data.oldPassword) {
          setPasswordResetSuccess(null);
          setSameAsOldError(true);
        } else {
          setSameAsOldError(false);
          auth.currentUser
            .updatePassword(data.newPassword)
            .then(() => {
              // Clear input values
              setValue("oldPassword", "");
              setValue("newPassword", "");
              setPasswordResetSuccess("success");
            })
            .catch((error) => {
              console.log(error);
              setPasswordResetSuccess(null);
            });
        }
      })
      .catch((error) => {
        console.log(error);
        setLoginError(error.code);
        setPasswordResetSuccess(null);
      });
  };

  return (
    <div>
      <h1 className={classes.Title}>Account Settings</h1>
      {hasPassword ? (
        <>
          <p>
            Edit the information about your account, change your password, or
            deactivate the account.
          </p>
          <h2>Change your password</h2>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Input
              type="password"
              placeholder="Old password"
              error={
                errors.oldPassword ||
                sameAsOldError ||
                loginError === "auth/wrong-password"
                  ? "error"
                  : null
              }
              {...register("oldPassword", { required: true })}
            />
            {loginError === "auth/wrong-password" ? (
              <p className={classes.Error}>
                The entered password is not correct.
              </p>
            ) : null}
            <Input
              type="password"
              placeholder="New password"
              error={errors.newPassword || sameAsOldError ? "error" : null}
              {...register("newPassword", { required: true, minLength: 6 })}
            />
            {errors.newPassword && errors.newPassword.type === "minLength" ? (
              <p className={classes.Error}>Please select a longer password.</p>
            ) : null}
            {(errors.newPassword && errors.newPassword.type === "required") ||
            (errors.oldPassword && errors.oldPassword.type === "required") ? (
              <p className={classes.Error}>
                Please fill in all the required fields.
              </p>
            ) : null}
            {sameAsOldError ? (
              <p className={classes.Error}>
                The new password is the same as the old one.
              </p>
            ) : null}
            {passwordResetSuccess === "success" ? (
              <p className={classes.Success}>
                Your password has been changed successfully.
              </p>
            ) : null}
            {passwordResetSuccess === "loading" ? (
              <Spinner className={classes.Spinner} />
            ) : (
              <button type="submit">Change password</button>
            )}
          </form>
        </>
      ) : (
        <p>
          You cannot edit your email or password, because you're signed up via
          Google. You can deactivate your Art Prompts account below.
        </p>
      )}

      <h2>Deactivate your account</h2>
      <button onClick={deleteAccount}>Deactivate</button>
      <p className={classes.Warning}>
        Warning: this action cannot be taken back!
      </p>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userId: state.userId,
  email: state.email,
});

const mapDispatchToProps = (dispatch) => ({
  onUpdatePurchased: (purchased) =>
    dispatch(actions.updatePurchased(purchased)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountSettings);
